import React from 'react'
import ReactDOM from 'react-dom'
import { XMarkIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline'

const PriorityBookingErrorModal = ({ isOpen, onClose, eventName }) => {
  if (!isOpen) return null

  const modalContent = (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" 
      style={{ zIndex: 9999 }}
    >
      <div 
        className="absolute inset-0"
        onClick={onClose}
      />

      <div className="relative w-full max-w-md p-6 bg-white dark:bg-gray-800 shadow-xl rounded-lg mx-4" style={{ zIndex: 10000 }}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center gap-2">
            <ExclamationCircleIcon className="w-6 h-6 text-amber-600 dark:text-amber-500" />
            Membership Required
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <div className="text-gray-600 dark:text-gray-300">
            <p className="mb-3">
              Priority booking for <strong>{eventName}</strong> is only available to our members and supporters.
            </p>
            <p>
              To access priority booking and enjoy other exclusive benefits, please purchase a membership.
            </p>
          </div>

          <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-md p-4">
            <p className="text-sm text-amber-800 dark:text-amber-200">
              <strong>Member benefits include:</strong>
            </p>
            <ul className="text-sm text-amber-700 dark:text-amber-300 mt-2 space-y-1">
              <li>• Priority booking for all events</li>
              <li>• Exclusive discounts and offers</li>
              <li>• Special member-only events</li>
              <li>• Support your local arts centre</li>
            </ul>
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 rounded-md transition-colors"
            >
              Not Now
            </button>
            <a
              href="/memberships"
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors inline-flex items-center gap-2"
              onClick={onClose}
            >
              View Memberships
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
  
  // Use React Portal to render modal at document body level
  return ReactDOM.createPortal(modalContent, document.body)
}

export default PriorityBookingErrorModal